import { Customer } from '@sageworks/jpi';

export function getCustomerNameFromCustomer(customer: Customer) {
	if (customer?.firstName == null || customer?.lastName == null) {
		return customer?.name ?? '';
	}
	return `${customer?.firstName} ${customer?.lastName}`;
}
